module.exports = __webpack_public_path__ + "img/风筝.328e9222.png";